import React from 'react';
import styles from './Apps.module.css';

/** 패널을 누르면 어디로 가는지 알려주는 띠. 패널에 마우스를 올리면 올라온다 */
export const GoBar: React.FC<{ label: string }> = ({ label }) => (
    <span className={styles.goBar}>
        <span className={styles.goLabel}>{label}</span>
        <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
            <path d="M2 10L10 2M3.5 2H10V8.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
        </svg>
    </span>
);

export default GoBar;
